const configuredWhatsApp = import.meta.env.VITE_DEMO_WHATSAPP?.replace(/\D/g, "");

const DEFAULT_WHATSAPP = "5531982132421";

export const DEMO_WHATSAPP = configuredWhatsApp || DEFAULT_WHATSAPP;

export const businessTypes = [
  { value: "restaurante", label: "Restaurante" },
  { value: "lanchonete", label: "Lanchonete" },
  { value: "acaíteria", label: "Açaiteria" },
  { value: "delivery", label: "Operação de delivery" },
  { value: "outro", label: "Outro negócio de alimentação" },
] as const;

export const leadInterests = [
  { value: "conhecer", label: "Conhecer a plataforma" },
  { value: "plano", label: "Conhecer o plano de R$ 79,90" },
  { value: "pdv", label: "Organizar meu PDV" },
  { value: "atendimento", label: "Melhorar o atendimento" },
] as const;

export function buildWhatsAppUrl(data: {
  establishmentName: string;
  contactName: string;
  whatsapp: string;
  businessType: string;
  interest: string;
}) {
  if (!DEMO_WHATSAPP) return "";

  const message = [
    "Olá, Innovally! Quero conhecer a plataforma.",
    "",
    `Estabelecimento: ${data.establishmentName}`,
    `Contato: ${data.contactName}`,
    `WhatsApp: ${data.whatsapp}`,
    `Tipo de negócio: ${data.businessType}`,
    `Interesse: ${data.interest}`,
  ].join("\n");

  return `https://wa.me/${DEMO_WHATSAPP}?text=${encodeURIComponent(message)}`;
}

export const faqItems = [
  {
    question: "Para quais tipos de negócio a Innovally serve?",
    answer:
      "A plataforma foi pensada para restaurantes, lanchonetes, açaiterias e operações que trabalham com atendimento presencial, balcão, delivery ou uma combinação desses canais.",
  },
  {
    question: "Quanto custa o plano Innovally?",
    answer:
      "O plano completo custa R$ 79,90 por mês e reúne cardápio digital, pedidos online, PDV e gestão da operação.",
  },
  {
    question: "O que está incluído na plataforma?",
    answer:
      "Você tem acesso a cardápio digital, pedidos online, painel de pedidos, estoque, mesas, caixa, relatórios, gestão de entregadores e impressão automática dos pedidos.",
  },
  {
    question: "A Innovally cobra comissão sobre meus pedidos?",
    answer:
      "No seu canal próprio, a proposta é que 100% do valor da venda fique com o seu negócio, sem comissão da plataforma. Custos do meio de pagamento e da entrega continuam dependendo das condições que você escolher.",
  },
  {
    question: "Existe fidelidade ou multa para cancelar?",
    answer: "Não. Você pode usar a plataforma sem ficar preso a um contrato de longo prazo.",
  },
  {
    question: "Vou ter ajuda para começar?",
    answer:
      "Sim. O atendimento inicial é humano e orienta você nos primeiros passos para colocar a operação em ordem.",
  },
  {
    question: "A plataforma recebe atualizações?",
    answer:
      "Sim. A Innovally evolui continuamente para melhorar a experiência do restaurante e acompanhar novas necessidades da operação.",
  },
  {
    question: "Preciso trocar toda a minha operação?",
    answer:
      "Não. A implantação é orientada para encaixar a plataforma no fluxo que você já tem e organizar os pontos que mais geram retrabalho no dia a dia.",
  },
  {
    question: "A Innovally trabalha com delivery e impressão?",
    answer:
      "Sim. A proposta inclui centralizar os pedidos da operação e automatizar a impressão dos pedidos para que a equipe trabalhe com menos conferências manuais.",
  },
] as const;
